import { useTranslation } from 'react-i18next'
import { CheckCheck, Pin, PinOff, Volume2, VolumeOff, X } from 'lucide-react'

import { triggerToast } from '@/components/Toast'
import { Button } from '@/components/ui/button'

import { FilterDropdown } from './FilterDropdown'

export const DrawerHeader = ({
  isMuted,
  isPinned,
  toggleMute,
  togglePin,
  markAllAsRead,
  closeDrawer,
}: {
  isMuted: boolean
  isPinned: boolean
  toggleMute: () => void
  togglePin: () => void
  markAllAsRead: () => void
  closeDrawer: () => void
}) => {
  const { t } = useTranslation()

  const handleToggleMute = () => {
    const wasUnmuted = !isMuted
    toggleMute()
    // Show appropriate toast based on the action taken
    if (wasUnmuted) {
      triggerToast('success', t('notifications.mutedSuccessfully'))
    } else {
      triggerToast('success', t('notifications.unmutedSuccessfully'))
    }
  }

  return (
    <div className="pl-5 pt-4 pr-4 pb-1 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-primary-900 text-lg font-semibold m-0">
          {t('notifications.title')}
        </h2>
        <div className="flex items-center gap-3">
          <Button
            variant="text"
            className="p-1 min-w-0"
            onClick={markAllAsRead}
            aria-label={t('notifications.actions.markAllRead')}
            title={t('notifications.actions.markAllRead')}
          >
            <CheckCheck
              className="h-5 w-5"
              color="var(--Colors-Foreground-fg-quaternary-400)"
            />
          </Button>
          <Button
            variant="text"
            className="p-1 min-w-0"
            onClick={handleToggleMute}
            aria-label={
              isMuted
                ? t('notifications.actions.unmute')
                : t('notifications.actions.mute')
            }
            title={
              isMuted
                ? t('notifications.actions.unmute')
                : t('notifications.actions.mute')
            }
          >
            {isMuted ? (
              <VolumeOff
                className="h-5 w-5"
                color="var(--Colors-Foreground-fg-quaternary-400)"
              />
            ) : (
              <Volume2
                className="h-5 w-5"
                color="var(--Colors-Foreground-fg-quaternary-400)"
              />
            )}
          </Button>
          <FilterDropdown />
          <Button
            variant="text"
            className="p-1 min-w-0"
            onClick={togglePin}
            aria-label={
              isPinned
                ? t('notifications.actions.unpin')
                : t('notifications.actions.pin')
            }
            title={
              isPinned
                ? t('notifications.actions.unpin')
                : t('notifications.actions.pin')
            }
          >
            {isPinned ? (
              <PinOff
                className="h-5 w-5"
                color="var(--Colors-Foreground-fg-quaternary-400)"
              />
            ) : (
              <Pin
                className="h-5 w-5"
                color="var(--Colors-Foreground-fg-quaternary-400)"
              />
            )}
          </Button>
          <Button
            variant="text"
            className="p-1 min-w-0"
            onClick={closeDrawer}
            aria-label={t('common.close')}
          >
            <X
              className="h-5 w-5"
              color="var(--Colors-Foreground-fg-quaternary-400)"
            />
          </Button>
        </div>
      </div>
    </div>
  )
}
